export const SOLD_SUBSCRIPTION_STATUS = {
    PAID: 'paid',
    OPEN: 'open',
    CLOSED: 'closed',
};
